import type { ISeoData as ISeoDataSchema } from '../repositories/offers-comparison/entities/seo/SeoData';
import type { ISeoData } from '../types/redux/seoData';

export const prepareSeoData = (seoData?: ISeoDataSchema | null): ISeoData => {
  if (!seoData) {
    return {
      h1: 'Сравнение квартир',
      title: 'Сравнение квартир',
      description: 'Сравнение квартир по цене, площади и другим параметрам. Выбирайте на ЦИАН.',
    };
  }

  return seoData;
};
